var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Popover, Whisper } from 'rsuite';
function renderTooltip(contents) {
    return (_jsx(Popover, { children: contents }));
}
function HoverOverlay(props) {
    var contents = props.contents, children = props.children, delay = props.delay, onHover = props.onHover, followCursor = props.followCursor;
    var placement = props.placement === undefined ? 'auto' : props.placement;
    return (_jsx(Whisper
    // @ts-ignore
    , __assign({ 
        // @ts-ignore
        placement: placement, controlId: "control-id-hover-enterable", trigger: "hover", speaker: renderTooltip(contents), enterable: followCursor ? false : true, followCursor: followCursor ? true : false, onEntering: onHover !== undefined ? onHover : function () { }, delay: delay }, { children: children })));
}
export default HoverOverlay;
